import { Button, Dialog, DialogContent, DialogTitle } from '@mui/material';

import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import ContractTable from 'components/ui/tables/ContractTable';

const ContractsModal = (props) => {
  const { open, setOpen, data, onExcel, excelLoading = false } = props;
  const { t } = useTranslation();

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='lg'
      PaperProps={{
        className: '!base-border !shadow-none min-w-[75vw]',
      }}
    >
      <DialogTitle
        id='alert-dialog-title'
        className='!text-center !mb-5 !bg-[#CDCDCDC7]'
      >
        <span className='mr-4'>{t('contract.title')}</span>
        {/* Ro'yxatni Excel'ga olish (bir martalik xavfsiz havola orqali) */}
        {onExcel && (
          <Button
            variant='contained'
            color='success'
            size='small'
            className='!ml-2'
            onClick={onExcel}
            disabled={excelLoading}
            startIcon={<i className='bi bi-file-earmark-excel' />}
          >
            Excel
          </Button>
        )}
      </DialogTitle>

      <DialogContent>
        <div className='component-table-wrapper h-[calc(100vh-180px)]'>
          <ContractTable
            emitRefetch={{ refetch: false, setRefetch: () => {} }}
            tableName='contract'
            actionInfo={false}
            noActions
            data={data}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default memo(ContractsModal);
